import React from 'react';
import { FaCompassDrafting } from 'react-icons/fa6';
import { NavSubmenuDivider, NavSubmenuLabel } from './navMenuLayout';
import SurveyBudgetNavPanel from './survey/SurveyBudgetNavPanel';
import { canAccessAreaBudgetMenu } from './areaBudgetNavUtils';

const SURVEY_CHILD_ROUTES = [
  '/survey/map',
  '/survey/planning',
  '/survey/production-reports',
  '/budgets/survey',
  '/budgets/survey/new',
  '/budgets/management?area=survey',
  '/dailies/survey/new',
  '/dailies/management?area=survey',
  '/summary/survey',
];

export default function SurveyNavSection({
  MenuItem,
  SubMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  closeMobileSidebar,
}) {
  if (!hasMenuAccessOrChild('/survey', SURVEY_CHILD_ROUTES)) {
    return null;
  }

  const canAccessBudget = canAccessAreaBudgetMenu('survey', hasMenuAccess);

  return (
    <MenuItem customIcon={<FaCompassDrafting style={{ width: '24px', height: '24px' }} />} title="Survey" id="survey">
      {(canAccessBudget
        || hasMenuAccess('/survey/planning')
        || hasMenuAccess('/dailies/survey/new')
        || hasMenuAccess('/dailies/management?area=survey')) && (
        <>
          <NavSubmenuLabel>Planning</NavSubmenuLabel>
          {canAccessBudget && (
            <SurveyBudgetNavPanel
              SubMenuItem={SubMenuItem}
              hasMenuAccess={hasMenuAccess}
              closeMobileSidebar={closeMobileSidebar}
            />
          )}
          {hasMenuAccess('/survey/planning') && <SubMenuItem to="/survey/planning">Field Planning</SubMenuItem>}
          {hasMenuAccess('/dailies/survey/new') && <SubMenuItem to="/dailies/survey/new">New Daily</SubMenuItem>}
          {hasMenuAccess('/dailies/management?area=survey') && (
            <SubMenuItem to="/dailies/management?area=survey">Dailies Management</SubMenuItem>
          )}
        </>
      )}
      {(hasMenuAccess('/survey/map') || hasMenuAccess('/survey/production-reports')) && (
        <>
          <NavSubmenuDivider />
          <NavSubmenuLabel>Operations</NavSubmenuLabel>
          {hasMenuAccess('/survey/map') && <SubMenuItem to="/survey/map">📍 Map</SubMenuItem>}
          {hasMenuAccess('/survey/production-reports') && (
            <SubMenuItem to="/survey/production-reports">📈 Production Reports</SubMenuItem>
          )}
        </>
      )}
      {hasMenuAccess('/summary/survey') && (
        <>
          <NavSubmenuDivider />
          <NavSubmenuLabel>Reports</NavSubmenuLabel>
          <SubMenuItem to="/summary/survey">Summary</SubMenuItem>
        </>
      )}
    </MenuItem>
  );
}
